import React from "react";
import GuideLayout from "../../components/layout/GuideLayout";
import Section from "../../components/layout/Section";
import {
  Typography,
  Link,
  Box
} from "@mui/material";
import AccordionFAQ from "../../components/layout/AccordionFAQ";
import BulletList from "../../components/layout/BulletList";


const collect = [
  (<><Link href="/contact">Discord</Link> - just register your account and report/search using the bot commands!</>),
  (<><Link href="https://itemdb.com.br/articles/lebron">Itemdb</Link> - sign into your itemDB account to report trades!</>),
  (<><Link href="https://www.neopets.com/neoboards/boardlist.phtml?board=31">Neoboards</Link> - catch one of our boards and report on site!</>),
];


const generalQuestions = [
  {
    question: "Are you TNT?",
    answer: (<>
      No, none of our team is part of TNT in any capacity, but you can find info <Link href="/about-us">about us here</Link>! We do not work for Neopets and we do not have any direct contact with TNT. If you have an account specific thing, we are unable to help you. We recommend you <Link href="https://classic.support.neopets.com/hc/en-us/requests/new">send a ticket</Link> instead, which is the official avenue to reach Neopets Support.
    </>),
  },
  {
    question: "Is this free to use?",
    answer: (<>
      Our resources are free to use! We are not making any profit off this and while we accept <Link href="/support">donations</Link>, it is never required. Please enjoy and happy trading!
    </>),
  },
  {
    question: "Hey something looks weird. Is this a bug/mistake?",
    answer: (<>
      If you see something that looks totally wrong, please join our discord and let a team member know! See our <Link href="/contact">contact us</Link> page for the invite.
    </>),
  },
  {
    question: "Do you need more volunteers?",
    answer: (<>
      Thank you, but not at this time! Right now, our team size is what we consider a good balance where we can easily coordinate with each other and manage the project efficiently. We may ask for more volunteers in the future, but right now we are fully staffed.
    </>),
  },
  {
    question: "Do you accept donations?",
    answer: (<>
      Yes! We do incur a monthly cost to run the project, so any amount of donation helps us keep it running. If you would like to donate, check out our <Link href="/support">support</Link> page!
    </>),
  },
  {
    question: "I have an idea/suggestion for _____ feature - can this be made?",
    answer: (<>
      Please bring it up as feedback! While we make no promises on adding/changing features, we will be discussing all feedback internally at the very least. If a suggestion is beneficial for the community, does not compromise other parts of the project, and we have the resources to reasonably implement it, we will likely find a way. We've implemented a few features this way already!
    </>),
  },
];

const lebronQuestions = [
  {
    question: "What's Lebron and how do I use it?",
    answer: (<>
      Lebron is our NC value guide - please visit the <Link href="/guides/how-to-lebron">How to Use LebronBot</Link> guide for more details. The Lebron Value Guide is named after Sara's pet, Lebron, whose petpage is the host of our value guide onsite <Link href="https://www.neopets.com/~Lebron">(/~Lebron)</Link>.
    </>),
  },
  {
    question: "Do I have to report to Lebron?",
    answer: (<>
      Of course not. No one is obligated to use Lebron at all. However, reporting your trades accurately does help the community figure out what certain items may be trading at. Just like previous value guides, Lebron is NOT law. It is simply a suggestion. If you value an item differently, please use your own personal value.
    </>),
  },
  {
    question: "If you started in June 2025, do you have older data?",
    answer: (<>
      We have trades that were reported to our predecessor, OWLS. Their team sent over their trade data and we've migrated tens of thousands of reports into our system. If you have previously reported to OWLS, we kindly ask that you don't report again here so we can avoid duplicate reports. Thank you!
    </>),
  },
  {
    question: "Why can't I report an item that just came out?",
    answer: (<>
      Due to our strict input requirements, we have all existing items added into our database. This means that an item that is not included will be rejected. Therefore, brand new items cannot be reported immediately until we add them to our database. Our team will try to add them as soon as we can, but it may take some time as we are not always online. Please hold on to your reports until the new item names are ready!
    </>),
  },
  {
    question: "Why can't you automatically add new items?",
    answer: (<>
      We are not TNT so we have no way of knowing what items will come out and when.
    </>),
  },
  {
    question: "Why doesn't ____ have a value?",
    answer: (<>
      Value calculation and updates are scheduled for 3 times a month and will get assigned to items with 5+ recent valid reports. If you notice an item with a lot of recent reports but has yet to be assigned a value in 2-3 weeks, feel free to notify a team member to investigate.
    </>),
  },
  {
    question: "Why does the value for ____ seem off?",
    answer: (<>
      We try our best to have our value calculator account for different types of data, but if something looks very wrong and is not flagged appropriately, let us know in <b>#help</b> in our <Link href="/contact">server</Link>! Please note: If there are not enough reports to justify a value change, the best we can do is flag volatility to encourage people to double check the item. We are aware that there are some high valued items that do not appear to warrant their value, however, we really need more reports! Our values are backed by community reported data so to maintain integrity, we do not change values until there is sufficient data, otherwise we'd be no better than just being one random group who arbitrarily makes up values.
    </>),
  },
  {
    question: "Is there a userscript for Lebron values?",
    answer: (<>
      Yes! Check out the <Link href="/userscript">userscript page</Link> for more information and the full code.

    </>),
  },
  {
    question: "In the userscript/petpage, I see a * next to some item values - what does that mean?",
    answer: (<>
      An asterisk indicates trade data volatility/instability. Our algorithm flags trades whenever it notices an unusual pattern (this is common with recently re-released items, or items with few recent reports). We always advise you to review the trade reports for yourself, but especially with these items as our calculated value is likely not the full story!
    </>),
  },
  {
    question: "Do you keep track of tokens/nonwearables?",
    answer: (<>
      Yes! We have support for token values and nonwearables. We accept all nc trade reports, so feel free to search for any tradeable nc item! We have a token value guide on site as well, but please note that it is very minimal at the moment. We do not have many token reports, so if you trade any, please report your trades so that we can better support the community. Our data is only as good as the reports we receive!
    </>),
  },
  {
    question: "Can I add Lebronbot to my own server?",
    answer: (<>
      Yes! To add, just click on the profile and click on the add app. The actual bot may not necessarily show up on your members list if you add to a server, but you can test that it's properly added by trying a slash command and see if the Lebron command appears.

      <Box sx={{ textAlign: "center" }}>
        <img src={require('../../assets/addlebron1.png')} alt="example of itemstats command" style={{ maxWidth: "80%", borderRadius: 8, marginTop: 16 }} />
      </Box>
    </>),
  },
  {
    question: "Can I dm Lebron for values and reports?",
    answer: (<>
      Yes, that is always an option! Slash commands will work in a dm with Lebron, so feel free to use them as you please.
    </>),
  },
  {
    question: "I made a mistake on my report! How do I edit/delete it?",
    answer: (<>
      Users can't edit/delete reports on their own, but we can certainly edit/delete it for you manually on our end! Please join our <Link href="/contact">server</Link> and post in the <b>#help</b> channel or create a ticket. Let us know your username and any trade identifying information so we can locate your trade in the database to edit/delete it. Alternatively, if you want your information to stay private, feel free to post something like "hey! i need a report deleted/edited - can i dm someone the trade details?" and a team member will reply when available!
    </>),
  },
  {
    question: "I have a huge trade and I don't have enough characters! How do I report?",
    answer: (<>
      We have specific character limits in place to satisfy discord limits and other functions. We first recommend trying to split the trade (ex: if it's 20 item trade for 20 gbcs, you could report each item traded for a gbc). If the trade cannot be split up in any way, please contact us in the bot help channel. You will likely have to post/dm the trade details to a dev, who will try to find a way to safely bypass the limits manually.
    </>),
  },
  {
    question: "Why do you ask for my username?",
    answer: (<>
      We keep record of usernames in case we need to contact for clarifying information(ex: seemingly duplicate trades, trade amendments, etc). When searching for reports, usernames will never be shown so users will never see who reported a trade. The only people who can see usernames are team members with admin access. If you'd like more information on how data is used, please visit our <Link href="/privacy-policy">privacy policy</Link>.
    </>),
  },
  {
    question: "How do you handle re-releases?",
    answer: (<>
      We reset values when items get rereleased, specifically when they are made buyable in the NC Mall and obtainable without having to rely on chance/luck (typically dyeworks, overstock, etc). To be very clear, this means it does not apply to items in rerelease capsules as that requires a chance element and specific items are not guaranteed. We also mark rereleased items as volatile, and that flag will disappear when the item gets enough stable reports to establish a proper value. From the start of the guide (June 2025), we reset values for all rereleased items in the past 3 months as we felt that timeframe could confidently be considered as recent. For items that were rereleased prior, we will wait for stable reports in order for a value change.
    </>),
  },
  {
    question: "You say you're just a guide but how is anyone supposed to disagree with the values?",
    answer: (<>
      <Typography paragraph>
        We stress that we are not trading law and that we are a value <b>guide</b> a lot. Our calculated values are based off the trade data we have, but it is definitely okay to disagree to values, especially if you believe something is overvalued/undervalued/outdated. There's so many items out there, and even our own team will not agree with every item's value. In those cases, if your trade includes an item that you believe has an inaccurate value, please report it! Report it with the value you believe it should be and you can even put additional comments in the notes like "this is an overoffer. X item should not be at Y value!" for example. This can help people who search for the item's trading history and reporting new values will also help us recalculate when there's enough stable reports!
      </Typography>

      <Typography paragraph>
        The values we calculate are only as good as the data we receive and we rely solely on voluntary reports from the community. We encourage everyone to make informed trades and look up items that they are seeking/trading for any recent rereleases or value shifts. Our system is not perfect, and we will never claim it as so, but we do believe that the community should have an easy way to look up past trades/data, which is where our bot and value check boards comes in. At the end of the day, we have no control over individual users and how they chose to value their items, but we will always encourage informed trades. Please consider our bot a tool and use responsibly!
      </Typography>
    </>),
  },
  {
    question: "When do values get updated?",
    answer: (<>
      Values are updated 3 times a month. Prior to September 2025, we were updating twice a month, but after gathering more data, we have decided to schedule value calculations more frequently to keep up with the new releases and trades that come with it.
    </>),
  },
  {
    question: "Why doesn't the userscript/dti match what is on the website/bot?",
    answer: (<>
      We totally understand the desire for real-time updates on releases and notes. However, the userscript is built on a periodic update cycle rather than live syncing. This process is carefully managed by our developers to ensure stability, and any extra updates outside the schedule should not be treated as the norm as they require additional time and review by the team. For the latest data, you can always search items here and/or on lebronbot as those are updated in real-time as reports get submitted!
    </>),
  },
  {
    question: "How do values get calculated?",
    answer: (<>
      The short answer is that values are calculated with our algorithm that takes into account outliers and common values. For a more detailed answer (it's kinda complicated and long), please check out the <Link href="/about-us">about us</Link> page.
    </>),
  },
  {
    question: "Does that mean you're using AI to calculate values?",
    answer: (<>
      Our values are not AI generated. Our algorithm lacks the more complex features that artificial intelligence typically has nowadays. You can find more information on the <Link href="/about-us">about us</Link> page, but we do not use any sort of training models nor does our algorithm have any learning capabilities.
    </>),
  },
];

const websiteQuestions = [
  {
    question: "What is Stylisher?",
    answer: (<>
      <Typography>
        The Stylisher project is our team's efforts to create a central NC trading resource hub. On this website, you will find NC trading guides, articles about NC items, and other resources you may use freely. We are also the same team that manages the current value guide (Lebron). For more information, please visit the <Link href="/about-us">About Us</Link> page.
      </Typography>

      <Typography>
        Our project name comes from June's pet onsite named Stylisher, where we host her beginner's guide to NC <Link href="https://www.neopets.com/~Stylisher">(/~stylisher)</Link>. We decided to expand from a beginner guide into a larger project for the NC community, and Stylisher was a great, fitting name for it! Everything you see here is under the Stylisher project!
      </Typography>
    </>),
  },
  {
    question: "I'm new to NC trading - where do I start?",
    answer: (<>
      You can start with our <Link href="/guides/beginner-nc-guide">Beginner's Guide to Neocash</Link>!
    </>),
  },
  {
    question: "Who writes the guides on Stylisher?",
    answer: (<>
      We have different authors depending on the article/guide, but overall it is a team effort! Even if one person is writing most of the content, it will be posted for the entire team to review before going live.
    </>),
  },
  {
    question: "When will new content/updates be posted?",
    answer: (<>
      We have no regular schedule for content. The team works on resources like guides and articles on their free time, which can vary from week to week or even just day to day. Latest updates will be posted <Link href="/updates">here</Link> whenever they come out!
    </>),
  },
  {
    question: "Do you have a light/dark mode on this site?",
    answer: (<>
      Yes! We actually have 4 themes for users to use. If you are on the desktop site, click the palette icon on the top right to select a theme. If you are on mobile, open the navigation menu by tapping on the top left drawer icon. From there you can toggle themes with the same palette icon located at the end of the navigation list.
    </>),
  },
  {
    question: "Can I report trades with this site?",
    answer: (<>
      At this time, only searching reports is available. We have other avenues to report trades, so we recommend you checking those out instead!
      <BulletList items={collect} />
    </>),
  },
  {
    question: "I found a typo on this page / This info seems inaccurate - Who do I contact?",
    answer: (<>
      Please join our discord to contact us! You may post in a public channel or dm the relevant team member. We'll try to fix any typos quickly and for all other feedback, we will bring it up with the team and make amendments as necessary after further discussion!
    </>),
  },
];

const sections = [
  { id: "intro", title: "Questions & Answers" },
  { id: "website", title: "Stylisher Website" },
  { id: "lebron", title: "Lebron Value Guide" },
  { id: "general", title: "General" },

];

const QuestionsPage = () => {
  return (
    <GuideLayout sections={sections}>
      <Section id="intro" title="Questions & Answers">
        <Typography
          variant="caption"
          color="secondary"
          sx={{ mt: -1, mb: 2, display: "block" }}
        >
          Last updated: April 2026
        </Typography>
        <Typography paragraph>
          Here's a bunch of questions that we've been asked before and some that we anticipate. If you have additional questions that you are unable to find answers to on the site, please visit the <Link href="/contact">contact us</Link> page.
        </Typography>
      </Section>

      <Section id="website">
        <AccordionFAQ subheader={
          <Typography
            variant="h4"
            gutterBottom
            sx={theme => ({
              color: theme.palette.accent.main
            })}>
            Stylisher Website
          </Typography>}
          items={websiteQuestions} />
      </Section>

      <Section id="lebron">
        <AccordionFAQ subheader={
          <Typography
            variant="h4"
            gutterBottom
            sx={theme => ({
              color: theme.palette.accent.main
            })}>
            Lebron Value Guide
          </Typography>}
          items={lebronQuestions} />
      </Section>

      <Section id="general">
        <AccordionFAQ subheader={
          <Typography
            variant="h4"
            gutterBottom
            sx={theme => ({
              color: theme.palette.accent.main
            })}>
            General
          </Typography>}
          items={generalQuestions} />
      </Section>

    </GuideLayout>
  );
};

export default QuestionsPage;
